import React from 'react';
import PropTypes from 'prop-types';
import CancelledTag from '@/pages/_components/CancelledTag';
import CompletedTag from '@/pages/_components/CompletedTag';
import ExpiredTag from '@/pages/_components/ExpiredTag';
import { isExpired } from '@/utils/dateTimeUtils';

export default function StatusTags(props) {
  const { project } = props;

  if (project.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={project}/>
      </div>
    );
  }

  if (project.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={project}/>
      </div>
    );
  }

  if (isExpired(project.data.endDate)) {
    return (
      <div className="flex space-x-4">
        <ExpiredTag resource={project}/>
      </div>
    );
  }

  return null;
}

StatusTags.propTypes = {
  project: PropTypes.shape({
    data: PropTypes.shape({
      cancelled: PropTypes.bool,
      completed: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};
